document.addEventListener('DOMContentLoaded', function() {
    const termsCheckbox = document.getElementById('terms-checkbox');
    const checkoutButton = document.getElementById('checkout');

    // Función para verificar si el checkbox está marcado
    function updateCheckoutButton() {
      if (termsCheckbox) {
        // Verificar si el carrito está vacío de forma segura
        const cartIsEmpty = typeof cart !== 'undefined' && cart.length === 0;
        checkoutButton.disabled = !termsCheckbox.checked || cartIsEmpty;
      }
    }

    // Agregar listener al checkbox
    if (termsCheckbox) {
      termsCheckbox.addEventListener('change', updateCheckoutButton);
      // Ejecutar al cargar la página
      updateCheckoutButton();
    }
    let currentCartValue = 0;
    let cartFetchInFlight = false;
    let cartFetchTimer = null;
    const listenerMarker = 'cardUpdateBound';

    // Verificar si existen los eventos de pub/sub de Shopify
    if (typeof window.PUB_SUB_EVENTS !== 'undefined') {
      // Suscribirse al evento cartUpdate
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function(event) {
        // Verificar si los datos del carrito están disponibles
        if (event.cartData && event.cartData.total_price !== undefined) {
          updateTotalPrice(event.cartData.total_price, event.cartData.currency);
        } else {
          // Si no hay datos del carrito, obtenerlos directamente
          scheduleCartRefresh();
        }
      });
    }
  
    // Obtener el estado actual del carrito al cargar la página
    scheduleCartRefresh(0);
  
    // Agregar eventos para los botones de eliminar y cantidad
    function addCartEventListeners() {
      // Botones de eliminación
      const removeButtons = document.querySelectorAll('.remove-button');
      removeButtons.forEach(button => {
        if (button.dataset[listenerMarker] === 'true') return;
        button.dataset[listenerMarker] = 'true';
        button.addEventListener('click', function() {
          // Dar tiempo para que Shopify procese la eliminación
          scheduleCartRefresh(300);
        });
      });
  
      // Inputs de cantidad
      const quantityInputs = document.querySelectorAll('.quantity__input');
      quantityInputs.forEach(input => {
        if (input.dataset[listenerMarker] === 'true') return;
        input.dataset[listenerMarker] = 'true';
        input.addEventListener('change', function() {
          // Dar tiempo para que Shopify procese el cambio
          scheduleCartRefresh(300);
        });
      });
  
      // Botones de cantidad (+ y -)
      const quantityButtons = document.querySelectorAll('.quantity__button');
      quantityButtons.forEach(button => {
        if (button.dataset[listenerMarker] === 'true') return;
        button.dataset[listenerMarker] = 'true';
        button.addEventListener('click', function() {
          // Dar tiempo para que Shopify procese el cambio
          scheduleCartRefresh(300);
        });
      });
    }
  
    // Agregar eventos iniciales
    addCartEventListeners();
  
    function scheduleCartRefresh(delay = 300) {
      clearTimeout(cartFetchTimer);
      cartFetchTimer = setTimeout(() => {
        cartFetchTimer = null;
        fetchCartAndUpdateTotal();
      }, delay);
    }

    // Función para obtener datos del carrito y actualizar el total
    function fetchCartAndUpdateTotal() {
      if (cartFetchInFlight) return Promise.resolve();

      cartFetchInFlight = true;

      return fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (cart.total_price !== currentCartValue) {
            // Actualizar el total solo si ha cambiado
            updateTotalPrice(cart.total_price, cart.currency);
            currentCartValue = cart.total_price;
          }
        })
        .catch(error => console.error('Error fetching cart:', error))
        .finally(() => {
          cartFetchInFlight = false;
        });
    }
  
    // Función para actualizar el precio total en la interfaz
    function updateTotalPrice(price, currency) {
      const totalValueElement = document.querySelector('.totals__total-value');
      if (totalValueElement) {
        totalValueElement.textContent = formatMoney(price, currency);
      }
    }
  
    // Función para formatear el precio según la moneda
    function formatMoney(cents, currency) {
      // Convertir centavos a unidades monetarias
      const amount = cents / 100;
      
      // Usar Intl.NumberFormat para formatear según la moneda
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: currency || 'COP',
        minimumFractionDigits: 2
      }).format(amount);
    }
  
    // Observar cambios en el DOM para volver a asignar eventos si se actualiza el carrito
    const observer = new MutationObserver(function(mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Si se añaden nuevos nodos, verificar si necesitamos volver a agregar eventos
          addCartEventListeners();
          scheduleCartRefresh(150);
          break;
        }
      }
    });
  
    // Observar el contenedor del carrito
    const cartContainer = document.querySelector('#main-cart-items');
    if (cartContainer) {
      observer.observe(cartContainer, {
        childList: true,
        subtree: true
      });
    }
  
    // Verificar también si necesitamos mejorar el método getSectionsToRender
    if (customElements.get('cart-items')) {
      const cartItemsElement = document.querySelector('cart-items');
      if (cartItemsElement) {
        // Asegurarse de que el contenedor del subtotal tenga un ID
        const subtotalContainer = document.querySelector('.totals');
        if (subtotalContainer && !subtotalContainer.id) {
          subtotalContainer.id = 'cart-subtotal-container';
        }
  
        // Patchar el método getSectionsToRender si es necesario
        const originalGetSectionsToRender = cartItemsElement.getSectionsToRender;
        cartItemsElement.getSectionsToRender = function() {
          const sections = originalGetSectionsToRender.call(this);
          
          // Verificar que 'main-cart-footer' esté incluido y tenga el selector correcto
          const mainCartFooterSection = sections.find(section => section.id === 'main-cart-footer');
          if (mainCartFooterSection) {
            // Asegurarse de que el selector sea correcto
            mainCartFooterSection.selector = '.js-contents';
          }
          
          return sections;
        };
      }
    }
  });
